var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, placeholderState, ref, saveRecentSearch, setSiteCookies, storeGeolocationData, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, storeGeolocationData = ref.storeGeolocationData;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    this.render();
    this.bind();
    this.country = document.head.getAttribute('data-country') || 'US';
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /*
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /*
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, value;
    data = $trigger.data();
    value = data.value, lat = data.lat, lng = data.lng, division = data.division;
    data = {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /*
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeolocation, enableRecentSearches, experiments, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments);
    if (options != null) {
      enableGeolocation = options['enableGeolocation'] || options['LS-2613-current-location'];
      enableBetterUx = options['LS-2685-location-field-ux'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeolocation: enableGeolocation,
      enableRecentSearches: enableRecentSearches,
      enableBetterUx: enableBetterUx,
      experiments: experiments
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if (Groupon.LS.experiments['enableRecentLocations']) {
      saveRecentSearch(locSearch, 'location');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          Groupon.Utils.trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              Groupon.Utils.trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        Groupon.Utils.trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        Groupon.Utils.trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    Groupon.Utils.trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    Groupon.Utils.trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = _.extend(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      data = _.extend(data, {
        query: query,
        hasLocCookie: true
      });
      storeGeolocationData(current_location, currentLocationData);
      return this.redirectTo(data);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return Groupon.Utils.trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data) {
    var address, closestDivision, division, hasLocCookie, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division, hasLocCookie = data.hasLocCookie;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    Groupon.Utils.trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

//# sourceMappingURL=data:application/json;base64,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
